var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, placeholderState, ref, saveRecentSearch, setSiteCookies, storeGeolocationData, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, storeGeolocationData = ref.storeGeolocationData;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    this.render();
    this.bind();
    this.country = document.head.getAttribute('data-country') || 'US';
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /*
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /*
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, value;
    data = $trigger.data();
    value = data.value, lat = data.lat, lng = data.lng, division = data.division;
    data = {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /*
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeolocation, enableRecentSearches, experiments, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments);
    if (options != null) {
      enableGeolocation = options['enableGeolocation'] || options['LS-2613-current-location'];
      enableBetterUx = options['LS-2685-location-field-ux'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeolocation: enableGeolocation,
      enableRecentSearches: enableRecentSearches,
      enableBetterUx: enableBetterUx,
      experiments: experiments
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if (Groupon.LS.experiments['enableRecentLocations']) {
      saveRecentSearch(locSearch, 'location');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          Groupon.Utils.trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              Groupon.Utils.trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        Groupon.Utils.trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        Groupon.Utils.trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    Groupon.Utils.trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    Groupon.Utils.trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = _.extend(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      data = _.extend(data, {
        query: query,
        hasLocCookie: true
      });
      storeGeolocationData(current_location, currentLocationData);
      return this.redirectTo(data);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return Groupon.Utils.trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data) {
    var address, closestDivision, division, hasLocCookie, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division, hasLocCookie = data.hasLocCookie;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    Groupon.Utils.trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

//# sourceMappingURL=data:application/json;base64,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
